export const toggleAll = (isExpanded, jsonExplorer) => {
	const ulList = jsonExplorer.querySelectorAll('ul:not(.root-level)');

	ulList.forEach((ul) => {
		if (isExpanded) {
			ul.classList.remove('hidden');
		} else {
			ul.classList.add('hidden');
		}
	});
};
